<template>
    <div class="rank_box">
        <div class="r_data">
            <h5>排序维度：</h5>
            <div class="sort_select" id="sortSelect" @click.stop>
                <div class="data_tit">
                    <div class="data_default" @click="change">请选择
                        <i :class="isShow ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                    </div>
                    <ul class="dropdown" id="sortUl" style="height:0px;">
                        <li v-for="(item,index) in selectData" :key="index" @click="checkSelect(index)">
                            <input type="checkbox" :checked="item.isChecked" />{{item.name}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="divide "></div>
            <div class="sort_box">
                <div class="data_tit" v-for="(ite,i) in selectList" :key="i" @click="remove(i)">
                    {{ite.name}}<i class="el-icon-close"></i>
                </div>
            </div>
            <div class="sort_rank" :class="isSort ? 'current' : ''" v-if="JSON.stringify(selectedData) != '{}'" @click="orderField">
                <i></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['sortList'],
    data() {
        return {
            isShow: false,
            selectData: [],
            selectedData: {},
            selectList: [],
            isSort: true
        };
    },
    mounted() {
        let vm = this;
        // 初始化选择数据
        vm.sortList.forEach(element => {
            element.isChecked = false;
            vm.selectData.push(element);
        });

        // 点击外部关闭下拉框
        document.body.addEventListener('click', () => {
            vm.isShow = false;
            let div = document.getElementById('sortUl');
            if (div != null) {
                let div_height = div.offsetHeight;
                if (div_height) {
                    vm.toggleSlide('sortUl', '500');
                }
            }
        }, false);
    },
    methods: {
        // 切换下拉框显示状态
        change() {
            let vm = this;
            vm.isShow = !vm.isShow;
            vm.toggleSlide('sortUl', '500');
        },
        // 下拉框动画效果
        toggleSlide(id, s) {
            let div = document.querySelector('#' + id);
            div.style.transition = 'height ' + s + 'ms';
            div.style.overflow = 'hidden';
            
            // 动态计算下拉框高度（修复显示不全问题）
            setTimeout(() => {
                let div_height = div.offsetHeight;
                if (div_height) {
                    // 关闭状态
                    div.style.height = '0';
                    div.style.border = "none";
                } else {
                    // 打开状态：计算内容实际高度，限制最大高度为200px
                    const contentHeight = div.scrollHeight;
                    div.style.height = `${Math.min(contentHeight, 200)}px`;
                    div.style.border = "1px solid #bed2e5";
                    div.style.borderTop = "none";
                }
            }, 0);
        },
        // 选择下拉选项
        checkSelect(index) {
            let vm = this,
                pData = {};
            // 切换选中状态
            vm.$set(vm.selectData[index], "isChecked", !vm.selectData[index].isChecked);
            
            // 更新已选列表
            if (vm.selectData[index].isChecked) {
                vm.selectList.push(vm.selectData[index]);
            } else {
                vm.selectList.forEach((ele, j) => {
                    if (ele.value == vm.selectData[index].value) {
                        vm.selectList.splice(j, 1);
                    }
                });
            }
            
            // 触发数据更新
            pData = vm.getParams();
            vm.$emit('selectedData', pData);
        },
        // 移除已选选项
        remove(i) {
            let vm = this,
                pData = {};
            // 更新原数据的选中状态
            vm.selectData.forEach((ele, j) => {
                if (ele.value == vm.selectList[i].value) {
                    vm.$set(vm.selectData[j], 'isChecked', false);
                }
            });
            // 从已选列表中移除
            vm.selectList.splice(i, 1);
            // 触发数据更新
            pData = vm.getParams();
            vm.$emit('selectedData', pData);
        },
        // 切换排序方式
        orderField() {
            let vm = this, pData = {};
            vm.isSort = !vm.isSort;
            pData = vm.getParams();
            vm.$emit('selectedData', pData);
        },
        // 组装参数
        getParams() {
            let vm = this,
                orderType = 'desc';
            
            vm.selectedData = {}; // 重置
            
            // 设置排序字段
            vm.selectList.forEach(element => {
                vm.selectedData[element.value] = orderType;
            });
            
            // 确定排序方向
            if (JSON.stringify(vm.selectedData) !== "{}") {
                orderType = vm.isSort ? 'desc' : 'asc';
            }
            
            // 应用排序方向
            for (let key in vm.selectedData) {
                vm.selectedData[key] = orderType;
            }
            
            return vm.selectedData;
        }
    }
};
</script>

<style scoped lang="scss">
.data_title {
    height: 25px;
    border: solid 1px #c9d7e8;
    text-align: center;
    display: inline-block;
    float: left;
    border-radius: 3px;
    margin: 0 4px;
    position: relative; /* 提供下拉框定位上下文 */
    cursor: pointer;
    background: #f4f9fd;
}

.rank_box {
    float: left;
    padding: 8px 0;
    height: 25px;

    .r_data {
        float: left;
        color: #3b455f;
        font-size: 12px;

        h5 {
            font-weight: normal;
            line-height: 25px;
            float: left;
            color: #333333;
            margin: 0 8px 0 0; /* 增加间距 */
        }

        .sort_select {
            float: left;

            .data_tit {
                @extend .data_title;
                width: 90px;
                position: relative; /* 关键：确保下拉框相对于此元素定位 */

                .data_default {
                    line-height: 25px;
                    padding: 0 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .dropdown {
                    position: absolute;
                    top: 25px; /* 与父元素高度一致，避免间隙 */
                    left: -1px;
                    border: 1px solid #bed2e5;
                    border-top: none;
                    width: 90px;
                    z-index: 100; /* 提高层级避免被遮挡 */
                    background: #fff;
                    margin: 0;
                    padding: 0;
                    overflow-y: auto; /* 内容超出时显示滚动条 */
                    list-style: none;

                    li {
                        width: 100%;
                        padding: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: left;
                        line-height: 25px;
                        background: #fbfbfb;
                        cursor: pointer;

                        &:hover {
                            background: #f0f7ff; /* 增加hover效果 */
                        }

                        input {
                            vertical-align: middle;
                            margin: 0 10px;
                        }
                    }
                }
            }
        }

        .divide {
            float: left;
            line-height: 25px;
            margin: 0 8px;
            color: #c9d7e8;
        }

        .sort_box {
            float: left;
            color: #3b455f;
            margin-left: 5px;

            .data_tit {
                @extend .data_title;
                line-height: 25px;
                padding: 0 10px;
                margin: 0 4px 0 0;

                i {
                    margin-left: 5px;
                    color: #999;
                }

                &:hover {
                    background: #eef5fb;
                }
            }
        }

        .sort_rank {
            float: left;
            line-height: 32px;
            cursor: pointer;
            display: inline-block;
            margin-left: 5px;

            i {
                width: 9px;
                height: 13px;
                background: url("./../../assets/images/rank.png") no-repeat;
                display: inline-block;
                margin-top: 8px;
            }
        }

        .current i {
            background: url("./../../assets/images/rank1.png") no-repeat;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Components/Sort.vue